"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoginFormSubmit = void 0;
const react_1 = require("react");
const helpers_1 = require("../../helpers");
const LoginSection_1 = require("./..");
function useLoginFormSubmit({ handler, busyModel, form, error: externalError, onRequestMFACode, onSuccess, twoStepsLoginMode, stepLoginMode = LoginSection_1.LOGIN_MODE_STEPS.login, onChangeStepLoginMode }) {
    const unmountRef = (0, react_1.useRef)(false);
    const errorState = (0, helpers_1.useStateValue)('');
    const [errorHighlight, setErrorHighlight] = (0, react_1.useState)(false);
    const [isSubmitted, setSubmittedStatus] = (0, react_1.useState)(false);
    const prevStepLoginModeRef = (0, react_1.useRef)(stepLoginMode);
    const fieldFocusHandler = () => {
        setErrorHighlight(false);
    };
    (0, react_1.useEffect)(() => {
        return () => {
            unmountRef.current = true;
        };
    }, []);
    (0, react_1.useEffect)(() => {
        errorState.setValue(externalError || '');
        setErrorHighlight(!!externalError);
    }, [externalError]);
    (0, react_1.useEffect)(() => {
        if (twoStepsLoginMode &&
            stepLoginMode === LoginSection_1.LOGIN_MODE_STEPS.login &&
            prevStepLoginModeRef.current === LoginSection_1.LOGIN_MODE_STEPS.password) {
            errorState.setValue('');
            setErrorHighlight(false);
        }
        prevStepLoginModeRef.current = stepLoginMode;
    }, [twoStepsLoginMode, stepLoginMode]);
    const submit = () => {
        const isValid = form.validateAndDisplayErrors();
        if (isValid) {
            setSubmittedStatus(true);
            (() => __awaiter(this, void 0, void 0, function* () {
                try {
                    let requestMFA = false;
                    busyModel.update((value) => {
                        value.loading = true;
                    });
                    errorState.setValue('');
                    let error = yield (handler === null || handler === void 0 ? void 0 : handler(form.getValue()));
                    if (onRequestMFACode && error === LoginSection_1.MFA_REQUEST_CODE) {
                        error = '';
                        requestMFA = true;
                    }
                    if (twoStepsLoginMode && error === LoginSection_1.REQUIRED_PASSWORD_CODE) {
                        error = '';
                        onChangeStepLoginMode === null || onChangeStepLoginMode === void 0 ? void 0 : onChangeStepLoginMode(LoginSection_1.LOGIN_MODE_STEPS.password, form.model.getValue());
                    }
                    if (!unmountRef.current) {
                        errorState.setValue(error || '');
                        setErrorHighlight(!!error);
                    }
                    if (requestMFA) {
                        onRequestMFACode === null || onRequestMFACode === void 0 ? void 0 : onRequestMFACode();
                    }
                    if (!error && !requestMFA) {
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    }
                }
                catch (err) {
                    errorState.setValue(err.message);
                    setErrorHighlight(true);
                }
                finally {
                    busyModel.update((value) => {
                        value.loading = false;
                    });
                }
            }))();
        }
    };
    const keyDownHandler = (e) => {
        if (e.key === 'Enter') {
            submit();
        }
    };
    return {
        hasError: !!errorState.getValue(),
        errorHighlight: errorHighlight,
        fieldFocusHandler,
        keyDownHandler,
        error: errorState.getValue(),
        submit,
        isSubmitted
    };
}
exports.useLoginFormSubmit = useLoginFormSubmit;
//# sourceMappingURL=useLoginFormSubmit.js.map